/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  CONFIRMATION_ROW_LOANNUMBER: 'settings.loans.confirmation.row.loanNumber',
  HOME_ROWSDATA_EMAIL_BUTTON_LABEL: 'settings.profile.home.rowsdata.email.button.label',
  HOME_ROWSDATA_EMAIL_LABEL: 'settings.profile.home.rowsdata.email.label',
  HOME_ROWSDATA_LEGALNAME_BUTTON_LABEL: 'settings.profile.home.rowsdata.legalName.button.label',
  HOME_ROWSDATA_LEGALNAME_LABEL: 'settings.profile.home.rowsdata.legalName.label',
  HOME_ROWSDATA_MILITARYSTATUS_BUTTON_LABEL: 'settings.profile.home.rowsdata.militaryStatus.button.label',
  HOME_ROWSDATA_MILITARYSTATUS_LABEL: 'settings.profile.home.rowsdata.militaryStatus.label',
  HOME_ROWSDATA_MOBILE_BUTTON_LABEL: 'settings.profile.home.rowsdata.mobile.button.label',
  HOME_ROWSDATA_MOBILE_LABEL: 'settings.profile.home.rowsdata.mobile.label',
  HOME_ROWSDATA_USERNAME_BUTTON_LABEL: 'settings.profile.home.rowsdata.username.button.label',
  HOME_ROWSDATA_USERNAME_LABEL: 'settings.profile.home.rowsdata.username.label',
  PROFILECONTENT_EDITLEGALNAME_UPLOADVIEW_TEXT_DIVORCE_SUBHEADER: 'settings.profile.profileContent.editLegalName.uploadView.text.divorce.subHeader',
};

const enMessages = {
  [IDS.CONFIRMATION_ROW_LOANNUMBER]: 'Loan Number',
  [IDS.HOME_ROWSDATA_EMAIL_BUTTON_LABEL]: 'edit email address',
  [IDS.HOME_ROWSDATA_EMAIL_LABEL]: 'Email',
  [IDS.HOME_ROWSDATA_LEGALNAME_BUTTON_LABEL]: 'edit legal name',
  [IDS.HOME_ROWSDATA_LEGALNAME_LABEL]: 'Loan Legal Name',
  [IDS.HOME_ROWSDATA_MILITARYSTATUS_BUTTON_LABEL]: 'edit military status',
  [IDS.HOME_ROWSDATA_MILITARYSTATUS_LABEL]: 'Loan Military Status (Optional)',
  [IDS.HOME_ROWSDATA_MOBILE_BUTTON_LABEL]: 'edit mobile number',
  [IDS.HOME_ROWSDATA_MOBILE_LABEL]: 'Mobile Number',
  [IDS.HOME_ROWSDATA_USERNAME_LABEL]: 'Username',
  [IDS.PROFILECONTENT_EDITLEGALNAME_UPLOADVIEW_TEXT_DIVORCE_SUBHEADER]: 'Document must include language to change the borrower’s name, and must be signed by a judge.',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.CONFIRMATION_ROW_LOANNUMBER]: 'Account Number',
  [IDS.HOME_ROWSDATA_LEGALNAME_LABEL]: 'Account Legal Name',
  [IDS.HOME_ROWSDATA_MILITARYSTATUS_LABEL]: 'Account Military Status (Optional)',
  [IDS.PROFILECONTENT_EDITLEGALNAME_UPLOADVIEW_TEXT_DIVORCE_SUBHEADER]: 'Document must include language to change the debtor’s name, and must be signed by a judge.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
